import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../../../components/grid";
import { getBillingServices, editClientData, UpdateBillingServices } from "../../../../../store/actions";
import RadioBoxRenderer from '../../../../../components/grid/RadiosRenderer'
import { sortBy } from 'lodash';
class ManagementOverviewView extends Component {
  state = {
    loading: false,
    isSelectedRowData: "",
    isShow: false,
    isAddOrderShow: false,
    billingServices: [],
    columnDefs: [

      {
        headerName: "Service Name",
        field: "serviceName",
        width: 110,
        flex: 1,

      },
      {
        headerName: "Description",
        field: "description",
        resizable: true,
        width: 150,
        flex: 1,

      },
      {
        headerName: "Created At",
        field: "createdAt",
        resizable: true,
        width: 150,
        flex: 1,
        valueFormatter: params => new Date(params.value).toLocaleString()
      },
      {
        headerName: "Billing Frequency",
        field: "billingFrequency",
        resizable: true,
        width: 150,
        flex: 1,
        cellRenderer: RadioBoxRenderer,
        cellRendererParams: {
          onChanged: (params) => this.onClickBillingFrequency(params),
          nameProp: "systemId",
          radioValues: [{ val: "Annual", label: "Year-End" }, { val: "Once", label: "Once" }, { val: "Recurring", label: "Recurring" }]
        },
      }

    ],
    rowData: [],
  };
  searchText = "";
  usersPayload = {};
  billingServices = [];

  async componentDidMount() {
    await this.props.getBillingServices();
    this.setState({ rowData: this.setRowData() });
  };

  searchInput = (e) => {
    this.searchText = e.target.value;
    this.setState({ rowData: this.setRowData() });

  }

  setRowData = () => {
    let searchFilter = this.searchText.toLowerCase();
    let rowData = this.props.BillingServicesReducer;
    if (rowData?.length) {
      rowData = rowData.filter(service => service.serviceName.toLowerCase().includes(searchFilter));
    };
    return sortBy(rowData, "serviceName");
  };

  saveServices = async () => {
    let payload = {
      billingServices: this.state.billingServices
    }
    await this.props.UpdateBillingServices(payload);
  };

  onClickBillingFrequency = (data) => {

    let findIndex = this.billingServices.findIndex(res => res.systemId === data.systemId);
    if (findIndex === -1) {
      this.billingServices.push(data)
    } else {
      this.billingServices[findIndex] = data;
    }
    this.setState({ billingServices: this.billingServices });
  }


  render() {
    const { billingServices } = this.state;
    return (
      <>
        <div className="shadow_white_box full-box mt-0">
          <div className="filter-list d-flex align-items-center justify-content-between">
            <div className="filter-field d-flex">
              <input type="text" placeholder="Search" autoComplete="off" onChange={(e) => this.searchInput(e)} />
            </div>

            <div className="filter-field d-flex">
              <button className="mla fs12 primary mini" onClick={this.saveServices} disabled={!billingServices.length}>Save</button>
            </div>
          </div>
          <div className="clients_grid">
            <Grid
              columnDefs={this.state.columnDefs}
              rowData={this.state.rowData}
              height='600px'
            >
            </Grid>
          </div>

        </div>

      </>
    )
  }
}


const mapStateToProps = ({ BillingServicesReducer }) => ({ BillingServicesReducer });
export default connect(mapStateToProps, { getBillingServices, editClientData, UpdateBillingServices })(ManagementOverviewView);
